import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/www/components/locale-switcher/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentManager","ConsentManagerButton"] */ "/vercel/path0/apps/www/components/materia/consent-manager/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/components/materia/prefooter-newsletter-form/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/components/materia/footer/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Submit"] */ "/vercel/path0/apps/www/components/materia/prefooter-newsletter-form/submit/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/www/components/materia/social-block/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionContent","AccordionItem","AccordionToggle"] */ "/vercel/path0/packages/mds-react/dist/components/accordion/item/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Item"] */ "/vercel/path0/packages/mds-react/dist/components/breadcrumbs/item/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["TruncationButton"] */ "/vercel/path0/packages/mds-react/dist/components/breadcrumbs/truncation-button/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Card","CardContent"] */ "/vercel/path0/packages/mds-react/dist/components/card/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlock"] */ "/vercel/path0/packages/mds-react/dist/components/code-block/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ComboBox","Root","Trigger","Value","Popover","SearchInput","List","Item"] */ "/vercel/path0/packages/mds-react/dist/components/combo-box-primitive/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["DisclosurePrimitive"] */ "/vercel/path0/packages/mds-react/dist/components/disclosure-primitive/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["useDisclosurePrimitive"] */ "/vercel/path0/packages/mds-react/dist/components/disclosure-primitive/use-disclosure-primitive.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToggleButton"] */ "/vercel/path0/packages/mds-react/dist/components/dropdown/toggle-button/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/mds-react/dist/components/flight-icon/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["CheckboxBase","CheckboxField","CheckboxGroup"] */ "/vercel/path0/packages/mds-react/dist/components/form/checkbox/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "/vercel/path0/packages/mds-react/dist/components/hds/wrappers/tooltip.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/mds-react/dist/components/interactive/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/mds-react/dist/components/menu-primitive/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ModalProvider"] */ "/vercel/path0/packages/mds-react/dist/components/modal/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["useModal"] */ "/vercel/path0/packages/mds-react/dist/components/modal/use-modal.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs"] */ "/vercel/path0/packages/mds-react/dist/components/tabs/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["useTabsContext"] */ "/vercel/path0/packages/mds-react/dist/components/tabs/use-tabs-context.js");
;
import(/* webpackMode: "eager", webpackExports: ["BarChart"] */ "/vercel/path0/packages/mds-react/dist/components/visualizations/bar-chart/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["DonutChart"] */ "/vercel/path0/packages/mds-react/dist/components/visualizations/donut-chart/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleContext"] */ "/vercel/path0/packages/mds-react/dist/utils/i18n/helpers/locale-provider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/mktg-logos/src/hashicorp/hashicorp-horizontal_on-dark.svg");
